<!--
 * @Author: lan.h
 * @Date: 2022-02-14 16:46:23
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-13 15:51:58
 * @Description: 专题pro
-->
<template>
  <div class="theme">
    <div class="theme-pro">
      <div class="spc_img" @click="toDetail()">
          <img :src="item.logoPath | logo_show"/>
          <span class="icon_column">专题Pro</span>
          <i class="iconfont collect-icon active" title="取消收藏" v-if="item.isCollect" @click.stop="cancelCollect('2', item.id, delCollectCb)">&#xe66f;</i>
          <i class="iconfont collect-icon" title="收藏" v-else @click.stop="addCollect('2', item.id, addCollectCb)">&#xe66f;</i>
      </div>
      <div class="spc_cnt">
        <a class="h1 over-p2" :href="$store.state.index_path + '/specialDetail/' + item.uid" target="_blank">{{item.title}}</a>
        <h2 class="over-p1">{{item.summary}}</h2>
        <div class="bot_cnt">
          <div>
            <div class="tags1" v-if="item.tracks && item.tracks.length > 0">
              <span>相关赛道</span>
              <a v-for="tag,tag_index in item.tracks" :key="tag" v-if="tag_index < 3" @click="toTrack(tag)">{{tag | dealNeed(entityNtag)}}</a>
            </div>
          </div>
          <div class="auth_time">
            <img v-if="item.authorInfo" @click="toAuthor(item.authorInfo)" :src="item.authorInfo.logoPath | logo_show('', $store.state.static_img_url + 'pic/vcbeat/no_face.jpg')"/>
            <span v-if="item.authorInfo" class="author" @click="toAuthor(item.authorInfo)">{{item.authorInfo.name}}</span>
            <span>{{item.sortTime | time_standard}}更新</span>
          </div>
        </div>
      </div>
    </div>
    <Entity v-if="item.entityInfos && item.entityInfos.length > 0" :entityInfos="item.entityInfos"></Entity>
  </div>
</template>

<script>
import Entity from './Entity'
import { collect_mixin } from "js/collect_mixin";
export default {
  mixins: [collect_mixin],
  props: ['item', 'entityNtag'],
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  components: { Entity },
  methods: {
    addCollectCb() {
      this.item.isCollect = true
    },
    delCollectCb() {
      this.item.isCollect = false
    },
    toDetail() {
      const href = this.$store.state.index_path + '/specialDetail/' + this.item.uid
      window.open(href, '_blank')
    },
    toAuthor(a) {
      const href = this.$store.state.index2_path + '/Article/authorArticle/keyword/' + a.id
      window.open(href, '_blank')
    },
    toTrack(tag) {
      const href = this.$store.state.index_path + '/trackDetail?tag=' + tag
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
.theme
  &-pro
    display flex
    .spc_img
      font-size 0
      position relative
      width 220px
      height 137px
      margin-right 12px
      overflow hidden
      cursor pointer
      .collect-icon
        position absolute
        top 10px
        right 10px
        width 18px
        height 18px
        text-align center
        line-height 18px
        color #ccc
        background-color #f3f3f3
        border-radius 2px
        font-size 10px
        display inline-block
        cursor pointer
        &:hover
        &.active
          color #fff
          background rgba(250, 122, 80, 1)
      img
        width 220px
        height 137px
        transition all .4s
        &:hover
          transform scale(1.1)
          transition all 0.6s ease 0s
    .spc_cnt
      flex 1
      position relative
      .h1
        margin-top 10px
        font-size 18px
        font-weight 550
        color #333333
        line-height 24px
        transition all .5s
        cursor pointer
        &:hover
          color #FA5A00
      h2
        font-size 13px
        font-weight 500
        color #666666
        line-height 20px
        margin-top 15px
      .bot_cnt
        margin-top 45px
        width 100%
        height 24px
        position absolute
        bottom 0
        left 0
        width 100%
        display flex 
        justify-content space-between
        align-items center
        .tags1
          flex 1
          span 
            font-size 12px
            
            font-weight 500
            color #999999
            line-height 18px
        .tags1
          a 
            background #FFF8F1
            border-radius 13px
            font-size 12px
            
            font-weight 400
            color #FA5A00
            line-height 1
            padding 6px 8px
            display inline-block
            margin-left 10px
            transition all .5s
            &:first-child
              margin-left 15px
            &:hover 
              background #FA5A00
              color #fff
      .auth_time
        text-align right
        color #999
        font-size 12px
        font-weight 500
        display flex 
        align-items center
        span 
          line-height 24px
        i 
          margin-right 6px
          font-size 12px
          height 11px
          display inline-block
          line-height 24px
        
        .author
          font-size 12px
          color #FA5A00
          margin-right 9px
          cursor pointer
          &:hover 
            color #FF4800
            transition all .5s
        img 
          width 20px
          height 20px
          border-radius 50%
          margin-right 5px
          cursor pointer
</style>
